import React from 'react';
import SummaryCards from './children/SummaryCards';
import BenchmarkBarChart from './children/BenchmarkBarChart';
import BenchmarkHeatmap from './children/BenchmarkHeatmap';
import KeyTakeAways from './children/KeyTakeAways';
import RatersResponseTable from './children/RatersResponseTable';
import SelfVsOtherPerception from './children/SelfVsOtherPerception';
import AlignmentInsights from './children/AlignmentInsights';
import LimitedVisibility from './children/LimitedVisibility';
import SampleComments from './children/SampleComments';

// Pure layout — each section gates its own loading/empty state internally (via
// AsyncSection keyed on the slice it already consumes), so this wrapper stays
// unconnected and never re-renders when a section's API resolves.
const ChartWrapper = () => {

    return (
        <>
            <SummaryCards />
            <RatersResponseTable />
            <BenchmarkBarChart />
            <KeyTakeAways />
            <BenchmarkHeatmap />
            <SelfVsOtherPerception />
            <AlignmentInsights />
            <LimitedVisibility />


            <SampleComments />
        </>
    );
};

export default ChartWrapper;
